<template>
  <v-page page="Search" :breadcrumb="breadcrumb">
    <Spinner ref="spinner"></Spinner>
    <v-container ma-0 px-0 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-0>
          <v-layout justify-center row align-center>
            
            <v-flex align-center xs12>
              <v-layout justify-start row align-center mt-4 mb-1 px-4>
                  <v-flex align-center>
                    <div
                      class="text-xs-left"
                      style="font-size: 20px; font-weight: 600;"
                    >Search</div>
                  </v-flex>
                </v-layout>
              <v-form v-model="valid" ref="searchForm" >
                
                <v-flex offset-xs2 xs8 align-center justify-center class="mt-4" :class="[{'middleSearch':!isSearch}]">
                  <v-flex v-if="!isSearch" class="mb-4 pr-5"><img src="~@/assets/img/logo.png" alt  /></v-flex>
                  
                  <v-layout row xs8 md8 lg8>
                    <v-flex xs3>
                      <v-autocomplete
                        label="What to search?"
                        :items="searchItems"
                        v-model="selectedSearchItem"
                        class="align-center mt-0 pt-0 mr-2"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="search"
                        label="Search"
                        single-line
                        :rules="requiredRules"
                        class="align-center mt-0 pt-0"
                        clearable
                        @keyup.enter="searchPress"
                        @click:clear="cancelSearch"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1>
                      <v-btn @click="searchPress" icon mx-2 class="TierButton my-0 py-0">
                        <v-icon style="font-size:18px">fa-search</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-progress-linear :indeterminate="true" :active="loading"></v-progress-linear>
                  </v-layout>
                </v-flex>
              </v-form>
              <v-flex></v-flex>
              <v-layout row v-if="noResults">
                <v-flex xs3 offset-xs3>No results found.</v-flex>
              </v-layout>
              <v-layout row>
                <v-expansion-panel class="elevation-0 mx-4" expand v-model="openPanel">
                  <v-expansion-panel-content v-if="totalAccountsByName > 0">
                    <template v-slot:header>
                      <div
                        class="subheading"
                        style="font-weight: 700;"
                      >Accounts ({{numberWithCommas(totalAccountsByName)}})</div>
                    </template>
                    <v-data-table
                      :headers="accountHeaders"
                      :items="accounts"
                      :item-key="accounts.index"
                      :loading="accountLoading"
                      :total-items="totalAccountsByName"
                      :pagination.sync="accountByNamePagination"
                      hide-details
                      class="striped-table no-pagination-btn"
                    >
                      <template slot="items" slot-scope="props">
                        <tr :key="props.index">
                          <td class="text-xs-left px-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["AccountType"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <router-link
                              class="mr-3"
                              style="text-decoration: none"
                              :to="openAccountSummaryPage( props.item.ParentBAN )"
                            >
                              <text-highlight
                                :queries="searchHighlight"
                              >{{ props.item["ParentBAN"] }}</text-highlight>
                            </router-link>
                          </td>
                          <td class="text-xs-left pr-0">
                            <router-link
                              class="mr-3"
                              style="text-decoration: none"
                              :to="openAccountSummaryPage(props.item.BAN)"
                            >
                              <text-highlight :queries="searchHighlight">{{ props.item["BAN"] }}</text-highlight>
                            </router-link>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["Name1"].trim() + (props.item["Name2"] ? props.item["Name2"].trim() : '') }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight :queries="searchHighlight">{{ props.item["City"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight :queries="searchHighlight">{{ props.item["StateProv"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight :queries="searchHighlight">{{ props.item["MailCode"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0" :style="{'color':props.item.StatusColor}">
                            <text-highlight :queries="searchHighlight">{{ props.item["Status"] }}</text-highlight>
                          </td>
                          <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                            <router-link
                              class="mr-2"
                              style="text-decoration: none"
                              :to="openEditAccount(props.item)"
                            >EDIT</router-link>
                            <router-link
                              class="mr-2"
                              style="text-decoration: none"
                              :to="openAccountSummaryPage(props.item.BAN)"
                            >VIEW</router-link>
                            <router-link
                              class="mr-0"
                              style="text-decoration: none"
                              :to="openAccountAuditLogs(props.item)"
                            >LOG</router-link>
                          </td>
                        </tr>
                      </template>
                      <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="accountByNamePagination.rowsPerPage" :totalRecords="totalAccountsByName" v-model="accountByNamePagination.page"></data-table-pagination>
                  </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content v-if="totalAccounts > 0">
                    <template v-slot:header>
                      <div
                        class="subheading"
                        style="font-weight: 700;"
                      >Accounts ({{numberWithCommas(totalAccounts)}})</div>
                    </template>
                    <v-data-table
                      :headers="accountHeaders"
                      :items="accounts"
                      :item-key="accounts.index"
                      :rows-per-page-items="accountRowsPerPageItems"
                      :pagination.sync="accountPagination"
                      :loading="accountLoading"
                      :total-items="totalAccounts"
                      @update:pagination="accountPaginationUpdated"
                      hide-details
                      class="striped-table no-pagination-btn"
                    >
                      <template slot="items" slot-scope="props">
                        <tr :key="props.index">
                          <td class="text-xs-left px-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["AccountType"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <router-link
                              class="mr-3"
                              style="text-decoration: none"
                              :to="openAccountSummaryPage(props.item.ParentBAN)"
                            >
                              <text-highlight
                                :queries="searchHighlight"
                              >{{ props.item["ParentBAN"] }}</text-highlight>
                            </router-link>
                          </td>
                          <td class="text-xs-left pr-0">
                            <router-link
                              class="mr-3"
                              style="text-decoration: none"
                              :to="openAccountSummaryPage(props.item.BAN)"
                            >
                              <text-highlight :queries="searchHighlight">{{ props.item["BAN"] }}</text-highlight>
                            </router-link>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["Name1"].trim() + (props.item["Name2"] ? props.item["Name2"].trim() : '') }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight :queries="searchHighlight">{{ props.item["City"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight :queries="searchHighlight">{{ props.item["StateProv"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight :queries="searchHighlight">{{ props.item["MailCode"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0" :style="{'color':props.item.StatusColor}">
                            <text-highlight :queries="searchHighlight">{{ props.item["Status"] }}</text-highlight>
                          </td>
                          <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                            <router-link
                              class="mr-2"
                              style="text-decoration: none"
                              :to="openEditAccount(props.item)"
                            >EDIT</router-link>
                            <router-link
                              class="mr-2"
                              style="text-decoration: none"
                              :to="openAccountSummaryPage(props.item.BAN)"
                            >VIEW</router-link>
                            <router-link
                              class="mr-0"
                              style="text-decoration: none"
                              :to="openAccountAuditLogs(props.item)"
                            >LOG</router-link>
                          </td>
                        </tr>
                      </template>
                      <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="accountPagination.rowsPerPage" :totalRecords="totalAccounts" v-model="accountPagination.page" @input="accountPaginationUpdated()"></data-table-pagination>
                  </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content v-if="totalServices > 0">
                    <template v-slot:header>
                      <div
                        class="subheading"
                        style="font-weight: 700;"
                      >Services ({{numberWithCommas(totalServices)}})</div>
                    </template>
                    <v-data-table
                      :headers="serviceHeaders"
                      :items="services"
                      :item-key="services.index"
                      :rows-per-page-items="serviceRowsPerPageItems"
                      :pagination.sync="servicesPagination"
                      :loading="servicesLoading"
                      :total-items="totalServices"
                      @update:pagination="servicePaginationUpdated"
                      hide-details
                      class="striped-table no-pagination-btn"
                    >
                      <template slot="items" slot-scope="props">
                        <tr :key="props.index">
                          <td class="text-xs-left px-0">
                            <router-link
                              class="mr-3"
                              style="text-decoration: none"
                              :to="openAccountSummaryPage(props.item.AccountBAN)"
                            >
                              <text-highlight
                                :queries="searchHighlight"
                              >{{ props.item["AccountBAN"] }}</text-highlight>
                            </router-link>
                          </td>
                          <td class="text-xs-left px-0">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <span v-on="on">
                                  <text-highlight
                                    :queries="searchHighlight"
                                  >{{ formatAccountName(props.item["AccountName1"], props.item["AccountName2"]) }}</text-highlight>
                                </span>
                              </template>
                              <span>{{props.item["AccountName2"] ? props.item["AccountName1"] +" "+ props.item["AccountName2"] : props.item["AccountName1"] }}</span>
                            </v-tooltip>
                          </td>
                          <td class="text-xs-left px-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["ElementType"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["ElementDescription"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["ServiceType"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight :queries="searchHighlight">{{ props.item["Provider"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["ServiceType"] === 'Wireless' && props.item["ElementType"] !="MDN" ? formatPN_helper(props.item["Element"]) : props.item["ElementType"] =="MDN"? formatSIM(props.item["Element"]): props.item["Element"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ formatSIM(props.item["SecondaryIdentifier"]) }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <span v-on="on">
                                  <text-highlight
                                    :queries="searchHighlight"
                                  >{{ formatServiceInfo(props.item["ServiceInfo"]) }}</text-highlight>
                                </span>
                              </template>
                              <span>{{ props.item["ServiceInfo"] }}</span>
                            </v-tooltip>
                          </td>
                          <td class="text-xs-left pr-0">
                            <v-layout row>
                              <v-flex xs4>
                                <text-highlight :queries="searchHighlight">{{ props.item["Inter"] }}</text-highlight>
                              </v-flex>
                              <v-flex xs4>
                                <text-highlight :queries="searchHighlight">{{ props.item["Intra"] }}</text-highlight>
                              </v-flex>
                              <v-flex xs4>
                                <text-highlight :queries="searchHighlight">{{ props.item["Intl"] }}</text-highlight>
                              </v-flex>
                            </v-layout>
                          </td>
                          <td
                            class="text-xs-left pr-0 pl-2"
                            :class="{'green--text': props.item.Status === 'Active', 'red--text': props.item.Status === 'Cancelled'}"
                          >
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["Status"] | uppercase }}</text-highlight>
                          </td>
                          <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                            <router-link
                              class="mr-2"
                              style="text-decoration: none"
                              :to="openEditServiceForm(props.item)"
                            >EDIT</router-link>
                            <router-link
                              class="mr-0"
                              style="text-decoration: none"
                              :to="openServiceAuditLogs(props.item)"
                            >LOG</router-link>
                          </td>
                        </tr>
                      </template>
                      <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="servicesPagination.rowsPerPage" :totalRecords="totalServices" v-model="servicesPagination.page" @input="servicePaginationUpdated()"></data-table-pagination>
                  </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content v-if="totalCharges > 0">
                    <template v-slot:header>
                      <div
                        class="subheading"
                        style="font-weight: 700;"
                      >Charges ({{numberWithCommas(totalCharges)}})</div>
                    </template>
                    <v-data-table
                      :headers="chargeHeaders"
                      :items="charges"
                      :item-key="charges.index"
                      :rows-per-page-items="chargeRowsPerPageItems"
                      :pagination.sync="chargesPagination"
                      :loading="chargesLoading"
                      :total-items="totalCharges"
                      @update:pagination="chargePaginationUpdated"
                      hide-details
                      class="striped-table no-pagination-btn"
                    >
                      <template slot="items" slot-scope="props">
                        <tr :key="props.index">
                          <td class="text-xs-left px-0">
                            <router-link
                              class="mr-3"
                              style="text-decoration: none"
                              :to="openAccountSummaryPage(props.item.AccountNumber)"
                            >
                              <text-highlight
                                :queries="searchHighlight"
                              >{{ props.item["AccountNumber"] }}</text-highlight>
                            </router-link>
                          </td>
                          <td class="text-xs-left px-0">
                            <text-highlight :queries="searchHighlight">
                              {{
                              (props.item["AccountName1"] + ' ' +
                              (props.item["AccountName2"] == null ? "" :props.item["AccountName2"])
                              ).trim() }}
                            </text-highlight>
                          </td>
                          <td class="text-xs-left px-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["ServiceType"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left px-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["ServiceType"] === 'Wireless' && props.item["ElementType"] !="MDN" ? formatPN_helper(props.item["ServiceIdentifier"]) : props.item["ElementType"] =="MDN"? formatSIM(props.item["ServiceIdentifier"]): props.item["ServiceIdentifier"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left px-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ formatSIM(props.item["SecondaryIdentifier"]) }}</text-highlight>
                          </td>
                          <td class="text-xs-left px-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["ChargeDescription"] }}</text-highlight>
                          </td>
                          <td
                            :class="{'justify-end text-xs-right pr-2 pt-0 pb-0': props.item.ChargeAmount >= 0, 'justify-end text-xs-right pr-2 pt-0 pb-0 red--text': props.item.ChargeAmount < 0}"
                          >
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ formatCurrency(props.item["ChargeAmount"]) }}</text-highlight>
                          </td>
                          <td class="text-xs-center px-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ formatDate(props.item["StartDate"]) }}</text-highlight>
                          </td>
                          <td class="text-xs-center px-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ formatDate(props.item["EndDate"]) }}</text-highlight>
                          </td>
                          <td
                            class="text-xs-center pl-0 pr-2"
                            :class="{'red--text': props.item.IsExpired === true, 'green--text': props.item.IsExpired === false}"
                          >
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["IsExpired"] == true ? "YES":"NO" }}</text-highlight>
                          </td>
                          <td
                            class="text-xs-left px-0"
                            :class="{'purple--text': props.item.ChargeFrequency === 'Monthly', 'orange--text': props.item.ChargeFrequency === 'One-time'}"
                          >
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["ChargeFrequency"] | uppercase }}</text-highlight>
                          </td>
                          <td class="text-xs-right px-0">
                            <router-link
                              class="mr-2"
                              style="text-decoration: none"
                              :to="openEditCharges(props.item)"
                            >EDIT</router-link>
                            <router-link
                              class="mr-0"
                              style="text-decoration: none"
                              :to="openChargeAuditLogs(props.item)"
                            >LOG</router-link>
                          </td>
                        </tr>
                      </template>
                      <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="chargesPagination.rowsPerPage" :totalRecords="totalCharges" v-model="chargesPagination.page" @input="chargePaginationUpdated()"></data-table-pagination>
                  </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content v-if="totalReceivables > 0">
                    <template v-slot:header>
                      <div
                        class="subheading"
                        style="font-weight: 700;"
                      >Receivables ({{numberWithCommas(totalReceivables)}})</div>
                    </template>
                    <v-data-table
                      :headers="receivablesHeaders"
                      :items="receivables"
                      :item-key="receivables.index"
                      :rows-per-page-items="receivablesRowsPerPageItems"
                      :pagination.sync="receivablesPagination"
                      :loading="receivablesLoading"
                      :total-items="totalReceivables"
                      @update:pagination="receivablesPaginationUpdated"
                      hide-details
                      class="striped-table no-pagination-btn"
                    >
                      <template slot="items" slot-scope="props">
                        <tr :key="props.index">
                          <td class="text-xs-left px-0">
                            <router-link
                              class="mr-3"
                              style="text-decoration: none"
                              :to="openAccountSummaryPage(props.item.AccountBAN)"
                            >
                              <text-highlight
                                :queries="searchHighlight"
                              >{{ props.item["AccountBAN"] }}</text-highlight>
                            </router-link>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight :queries="searchHighlight">
                              {{
                              (props.item["AccountName1"] + ' ' +
                              (props.item["AccountName2"] == null ? "" :props.item["AccountName2"])
                              ).trim() }}
                            </text-highlight>
                          </td>
                          <td class="text-xs-left px-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ formatDate(props.item["Date"]) }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["TypeDescription"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left pr-0">
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item["Description"] }}</text-highlight>
                          </td>
                          <td
                            :class="{'justify-end align-center text-xs-right pr-0 pt-0 pb-0': props.item.Amount >= 0, 'justify-end align-center text-xs-right pr-0 pt-0 pb-0 red--text': props.item.Amount < 0}"
                          >
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ formatCurrency(props.item["Amount"]) }}</text-highlight>
                          </td>
                          <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                            <a
                              v-show="props.item.Type == 'IN'"
                              class="mr-0"
                              style="text-decoration: none"
                              @click="exportReceivablesToPDF(props.item)"
                            >PDF</a>
                            <!-- <a
                              class="mr-2"
                              style="text-decoration: none"
                              @click="openViewReivables(props.item)"
                            >VIEW</a>-->
                          </td>
                        </tr>
                      </template>
                      <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="receivablesPagination.rowsPerPage" :totalRecords="totalReceivables" v-model="receivablesPagination.page" @input="receivablesPaginationUpdated()"></data-table-pagination>
                  </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content v-if="totalTickets > 0">
                    <template v-slot:header>
                      <div
                        class="subheading"
                        style="font-weight: 700;"
                      >Tickets ({{numberWithCommas(totalTickets)}})</div>
                    </template>
                    <v-data-table
                      :headers="ticketsHeaders"
                      :items="tickets"
                      :item-key="tickets.index"
                      :rows-per-page-items="ticketsRowsPerPageItems"
                      :pagination.sync="ticketsPagination"
                      :loading="ticketsLoading"
                      :total-items="totalTickets"
                      @update:pagination="ticketsPaginationUpdated"
                      hide-details
                      class="no-pagination-btn"
                    >
                      <template slot="items" slot-scope="props">
                        <tr
                          :key="props.index"
                          :active="props.selected"
                          :style="{
                            backgroundColor: (isEven(props.index) ? '#f9f9f9': 'transparent'), 
                            color: 'black',
                          }"
                        >
                          <!-- #009392 -->
                          <td class="text-xs-left px-0">
                            <text-highlight :queries="searchHighlight">{{ props.item["TicketId"] }}</text-highlight>
                          </td>
                          <td class="text-xs-left px-0">
                            <router-link
                              class="mr-3"
                              style="text-decoration: none"
                              :to="openAccountSummaryPage(props.item.AccountBAN)"
                            >
                              <text-highlight
                                :queries="searchHighlight"
                              >{{ props.item["AccountBAN"] }}</text-highlight>
                            </router-link>
                          </td>

                          <td
                            class="text-xs-left px-0"
                            :class="{'green--text': props.item.StatusId === 'A2', 'red--text': props.item.StatusId === 'A1'}"
                          >
                            <text-highlight
                              :queries="searchHighlight"
                            >{{ props.item.StatusId == 'A1' ? "OPEN" : "CLOSED"}}</text-highlight>
                          </td>

                          <td class="text-xs-left pl-0 pr-3">
                            <text-highlight :queries="searchHighlight">{{ props.item["Type"] }}</text-highlight>
                          </td>
                          <!-- <td class="text-xs-left px-0">{{ props.item["OpenDate"] | formatDateTime}}</td> -->

                          <td class="text-xs-left px-0 fill-width" colspan="3">
                            <v-layout
                              child-flex
                              v-for="(details, index) in props.item.Details"
                              row
                              wrap
                            >
                              <tr
                                :key="index"
                                class="fill-width"
                                :class="{ticketDetail: index+1 < props.item.Details.length? true:false}"
                              >
                                <v-layout class="fill-width">
                                  <v-flex style="width:17%; min-width:200px">
                                    <td class="text-xs-left px-0">
                                      <v-layout column>
                                        <v-flex>
                                          <text-highlight
                                            :queries="searchHighlight"
                                          >{{details.USUSERNAME}}</text-highlight>
                                        </v-flex>
                                        <!-- <v-divider v-if="index+1 < props.item.Details.length"></v-divider> -->
                                      </v-layout>
                                    </td>
                                  </v-flex>
                                  <v-flex style="width:16%; min-width:100px">
                                    <td class="text-xs-left px-0">
                                      <v-layout column>
                                        <v-flex>
                                          <text-highlight
                                            :queries="searchHighlight"
                                          >{{details.ACENTRYDATE | formatDateTime}}</text-highlight>
                                        </v-flex>
                                        <!-- <v-divider v-if="index+1 < props.item.Details.length"></v-divider> -->
                                      </v-layout>
                                    </td>
                                  </v-flex>
                                  <v-flex style="width:67%; min-width:200px">
                                    <td class="text-xs-left px-0">
                                      <v-layout column>
                                        <v-flex>
                                          <text-highlight
                                            :queries="searchHighlight"
                                          >{{details.ACDETAIL}}</text-highlight>
                                        </v-flex>
                                        <!-- <v-divider v-if="index+1 < props.item.Details.length"></v-divider> -->
                                      </v-layout>
                                    </td>
                                  </v-flex>
                                </v-layout>
                              </tr>
                            </v-layout>
                          </td>

                          <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                            <router-link
                              v-if="props.item.StatusId == 'A1'"
                              class="mr-0"
                              style="text-decoration: none"
                              :to="openEditTicket(props.item)"
                            >EDIT</router-link>
                            <a
                              class="mr-0"
                              v-if="props.item.StatusId == 'A2'"
                              style="text-decoration: none"
                              @click="reopenTicket(props.item)"
                            >REOPEN</a>
                          </td>
                        </tr>
                      </template>
                      <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="ticketsPagination.rowsPerPage" :totalRecords="totalTickets" v-model="ticketsPagination.page" @input="ticketsPaginationUpdated()"></data-table-pagination>
                  </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import TextHighlight from "vue-text-highlight";
import Spinner from "../../components/Spinner.vue";
import "@/assets/css/main.css";
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "Search",

  components: {
    VPage,
    "text-highlight": TextHighlight,
    Spinner,
    DataTablePagination
  },

  data: () => ({
    dialog: false,
    search: "",
    loading: false,
    filters: {},
    valid: true,
    searchHighlight: "",
    selectedSearchItem: "Everything",
    noResults: false,
    isSearch:false,
    searchItems: [
      {
        value: "Everything",
        text: "Everything"
      },
      {
        value: "Account #",
        text: "Account #"
      },
      {
        value: "Account Name",
        text: "Account Name"
      },
      {
        value: "Invoice #",
        text: "Invoice #"
      },
      {
        value: "Cell #",
        text: "Cell #"
      },
      {
        value: "SIM #",
        text: "SIM #"
      },
      {
        value: "Panel Id",
        text: "Panel Id"
      }
    ],
    openPanel: null,

    // ACCOUNT PANEL VARIABLES ----------------------------------------//
    accounts: [],
    accountLoading: false,
    totalAccounts: 0,
    totalAccountsByName: 0,
    accountPagination: {
      rowsPerPage: 10,
      descending: false,
      sortBy: "BAN",
      page: 1
    },
    accountByNamePagination: {
      rowsPerPage: -1,
      descending: false,
      sortBy: "BAN",
      page: 1
    },
    accountRowsPerPageItems: [10, 25, 50],
    accountByNameRowsPerPageItems: [],
    accountHeaders: [
      {
        text: "Type",
        value: "AccountType",
        width: "10%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Parent BAN",
        value: "ParentBAN",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "BAN",
        value: "BAN",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Name",
        value: "AccountName",
        // sortable: false,
        width: "40%",
        fixed: true,
        align: "left",
        class: "pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "City",
        value: "City",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "State/Prov",
        value: "StateProv",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Zip/Postal Code",
        value: "MailCode",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Status",
        value: "Status",
        // sortable: false,
        width: "13%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "8%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],

    // SERVICE PANEL VARIABLES ----------------------------------------//
    services: [],
    servicesLoading: false,
    totalServices: 0,
    servicesPagination: {
      rowsPerPage: 10,
      descending: false,
      sortBy: "AccountBAN",
      page: 1
    },
    serviceRowsPerPageItems: [10, 25, 50],
    serviceHeaders: [
      {
        text: "BAN",
        value: "AccountBAN",
        width: "4%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Name",
        value: "AccountName",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "El. Type",
        value: "ElementType",
        width: "6%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Desc.",
        value: "ElementDescription",
        // sortable: false,
        width: "8%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Service",
        value: "ServiceType",
        // sortable: false,
        width: "6%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Provider",
        value: "Provider",
        // sortable: false,
        width: "8%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Service ID",
        value: "Element",
        // sortable: false,
        width: "9%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Secondary ID",
        value: "SecondaryIdentifier",
        // sortable: false,
        width: "16%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Service Info",
        value: "ServiceInfo",
        // sortable: false,
        width: "14%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Rate Plan (Inter, Intra, Intl)",
        value: "Inter",
        // sortable: false,
        width: "10%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Status",
        value: "Status",
        // sortable: false,
        width: "4%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-2"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "5%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],

    // CHARGES PANEL VARIABLES ----------------------------------------//
    charges: [],
    chargesLoading: false,
    totalCharges: 0,
    chargesPagination: {
      rowsPerPage: 10,
      descending: false,
      sortBy: "AccountNumber",
      page: 1
    },
    chargeRowsPerPageItems: [10, 25, 50],
    chargeHeaders: [
      {
        text: "BAN",
        value: "AccountNumber",
        width: "4%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Name",
        value: "AccountName",
        width: "21%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Service",
        value: "ServiceType",
        width: "7%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Service ID",
        value: "ServiceIdentifier",
        width: "9%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Secondary ID",
        value: "SecondaryIdentifier",
        // sortable: false,
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-2 font-weight-bold subheading"
      },
      {
        text: "Charge",
        value: "ChargeDescription",
        width: "19%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Amount",
        value: "ChargeAmount",
        width: "7%",
        fixed: true,
        align: "right",
        class: "pl-0 pr-2 font-weight-bold subheading"
      },
      {
        text: "Effective Date",
        value: "StartDate",
        width: "9%",
        fixed: true,
        align: "center",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Expiry Date",
        value: "EndDate",
        width: "9%",
        fixed: true,
        align: "center",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Expired?",
        value: "IsExpired",
        width: "9%",
        fixed: true,
        align: "center",
        class: "pl-0 pr-2 font-weight-bold subheading"
      },
      {
        text: "Frequency",
        value: "ChargeFrequency",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Action",
        width: "7%",
        sortable: false,
        fixed: true,
        align: "right",
        class: "pl-0 pr-0 font-weight-bold subheading"
      }
    ],

    // RECEIVABLES PANEL VARIABLES --------------------------------------//
    receivables: [],
    receivablesLoading: false,
    totalReceivables: 0,
    receivablesPagination: {
      rowsPerPage: 10,
      descending: false,
      sortBy: "AccountBAN",
      page: 1
    },
    receivablesRowsPerPageItems: [10, 25, 50],
    receivablesHeaders: [
      {
        text: "BAN",
        value: "AccountBAN",
        width: "7%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Name",
        value: "AccountName",
        // sortable: false,
        width: "35%",
        fixed: true,
        align: "left",
        class: "pr-0 font-weight-bold subheading"
      },
      {
        text: "Date",
        value: "Date",
        width: "10%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Type",
        value: "TypeDescription",
        // sortable: false,
        width: "13%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Description",
        value: "Description",
        // sortable: false,
        width: "20%",
        fixed: true,
        align: "left",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Amount",
        value: "Amount",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "10%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],

    // TICKET PANEL VARIABLES -------------------------------------------//
    tickets: [],
    ticketsLoading: false,
    totalTickets: 0,
    ticketsPagination: {
      rowsPerPage: 10,
      descending: false,
      sortBy: "OpenDate",
      page: 1
    },
    ticketsRowsPerPageItems: [10, 25, 50],
    ticketsHeaders: [
      {
        text: "Ticket #",
        value: "TicketId",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "BAN",
        value: "AccountBAN",
        width: "5%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-0"
      },
      {
        text: "Status",
        value: "StatusId",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-0"
      },
      {
        text: "Type",
        value: "Type",
        // sortable: false,
        width: "11%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Username",
        value: "Username",
        // sortable: false,
        width: "12.15%",
        fixed: true,
        align: "left",
        class:
          "pl-0 pr-0 font-weight-bold subheading sort-asc ticketDetailColumn"
      },
      {
        text: "Date",
        value: "OpenDate",
        width: "12.50%",
        fixed: true,
        align: "left",
        class:
          "pl-0 pr-0 font-weight-bold subheading sort-asc ticketDetailCreatedColumn"
      },

      {
        text: "Note",
        value: "ACDETAIL",
        // sortable: false,
        width: "67%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "1%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],

    breadcrumb: [
      {
        text: "Search",
        disabled: false,
        href: "#/search"
      }
    ],
    requiredRules: [v => !!v || "Required"]
  }),
  mounted(){
    this.initialize()

  },

  methods: {
    initialize(){
      this.getLastSearchBy()
    },
    async searchPress() {
      if (this.$refs.searchForm.validate()) {
this.isSearch=true

        // SAVE LAST SEARCH BY 
        this.saveLastSearchBy()

        this.accounts = [];
        this.services = [];
        this.charges = [];
        this.receivables = [];
        this.tickets = [];
        this.totalAccounts = 0;
        this.totalServices = 0;
        this.totalCharges = 0;
        this.totalReceivables = 0;
        this.totalTickets = 0;
        this.openPanel = null;
        this.noResults = false;

        this.searchHighlight = this.search;

        this.loading = true;

        if (this.selectedSearchItem == "Everything") {
          await this.accountPaginationUpdated();
          await this.servicePaginationUpdated();
          await this.chargePaginationUpdated();
          await this.receivablesPaginationUpdated();
          await this.ticketsPaginationUpdated();
        } else if (this.selectedSearchItem == "Account #") {
          await this.getAccountByAccountNumber();
        } else if (this.selectedSearchItem == "Cell #") {
          await this.getWirelessServiceByWtn();
        } else if (this.selectedSearchItem == "SIM #") {
          await this.getWirelessServiceBySim();
        } else if (this.selectedSearchItem == "Invoice #") {
          await this.getInvoice();
        } else if (this.selectedSearchItem == "Panel Id") {
          await this.getPanel();
        } else if (this.selectedSearchItem == "Account Name") {
          await this.getAccountsByName();
        }

        if (
          this.accounts.length == 0 &&
          this.services.length == 0 &&
          this.charges.length == 0 &&
          this.receivables.length == 0 &&
          this.tickets.length == 0
        ) {
          this.noResults = true;
        }

        this.loading = false;
      }
    },
    async cancelSearch() {
      this.$router.go();
    },
    async accountPaginationUpdated() {
      this.accountLoading = true;
      await axios
        .post(
          "/api/Account/GetPagedAccountList/",
          {
            postData: {
              pagination: this.accountPagination,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.accounts = response.data.accounts;
          this.totalAccounts = response.data.totalRecords;
        });
      this.accountLoading = false;
    },
    async getAccountsByName() {
      this.accountLoading = true;
      await axios
        .get("api/Account/GetAccountsByName/" + this.search)
        .then(response => {
          this.accounts = response.data.accounts;
          this.totalAccountsByName = response.data.totalRecords;
          this.openPanel = 0;
        })
        .catch(error => {
          console.error(error);
        });
      this.accountLoading = false;
    },
    async getInvoice() {
      var invoices = null;
      await axios
        .get("api/Receivables/GetInvoice/" + this.search)
        .then(function(response) {
          invoices = response.data.receivables;
        })
        .catch(error => {
          console.log(error);
          this.noResults = true;
        });

      if (invoices != null) {
        this.receivables = invoices;
        this.$router.push(
          "Receivables/" +
            this.receivables[0].AccountBAN +
            "?search=" +
            this.search
        );
      }
    },
    async getAccountByAccountNumber() {
      var account = null;
      await axios
        .get("api/Account/GetAccount/" + this.search)
        .then(function(response) {
          account = response.data;
        })
        .catch(err => console.error(err));

      if (account != null) {
        this.accounts[0] = account;
        this.$router.push("/account-summary/" + account.BAN);
      }
    },
    async getWirelessServiceByWtn() {
      var serviceId = 0;
      await axios
        .get("api/Services/FindWirelessServiceByWtn/" + this.search)
        .then(function(response) {
          serviceId = response.data;
        })
        .catch(err => console.error(err));

      if (serviceId > 0) {
        this.services[0] = serviceId; // Set the value so that "No data found" is not shown before redirect
        this.$router.push("/services/all?ServiceId=" + serviceId);
      }
    },
    async getPanel() {
      var serviceId = 0;
      await axios
        .get("api/Services/FindPanelServiceByPanelId/" + this.search)
        .then(function(response) {
          serviceId = response.data;
        })
        .catch(err => console.error(err));

      if (serviceId > 0) {
        this.services[0] = serviceId; // Set the value so that "No data found" is not shown before redirect
        this.$router.push("/services/all?ServiceId=" + serviceId);
      }
    },
    async getWirelessServiceBySim() {
      var serviceIds = null;
      await axios
        .get("api/Services/FindWirelessServiceBySim/" + this.search)
        .then(function(response) {
          serviceIds = response.data;
        })
        .catch(err => console.error(err));

      //console.log(serviceIds);
      if (serviceIds == null) {
        this.noResults = true;
      } else if (serviceIds.length == 1) {
        this.services = serviceIds;
        this.$router.push("/services/all?ServiceId=" + serviceIds[0]);
      } else if (serviceIds.length > 1) {
        await this.servicePaginationUpdated();
      }
    },
    async servicePaginationUpdated() {
      this.servicesLoading = true;

      await axios
        .post(
          "/api/Services/GetPagedServiceList/",
          {
            postData: {
              pagination: this.servicesPagination,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.services = response.data.services;
          this.totalServices = response.data.totalRecords;
        });

      this.servicesLoading = false;
    },
    async chargePaginationUpdated() {
      this.chargesLoading = true;
      await axios
        .post(
          "/api/Charge/GetPagedChargeList/",
          {
            postData: {
              pagination: this.chargesPagination,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.charges = response.data.charges;
          this.totalCharges = response.data.totalRecords;
        });
      this.chargesLoading = false;
    },
    async receivablesPaginationUpdated() {
      this.receivablesLoading = true;
      await axios
        .post(
          "/api/Receivables/GetPagedReceivablesList/",
          {
            postData: {
              pagination: this.receivablesPagination,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.receivables = response.data.receivables;
          this.totalReceivables = response.data.pagination.totalRecords;
        });
      this.receivablesLoading = false;
    },
    async ticketsPaginationUpdated() {
      this.ticketsLoading = true;

      await axios
        .post(
          "/api/Tickets/GetPagedTicketList/",
          {
            postData: {
              pagination: this.ticketsPagination,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(async response => {
          this.tickets = await response.data.tickets;
          this.totalTickets = response.data.pagination.totalRecords;
        });

      this.ticketsLoading = false;
    },
    formatPN_helper(num) {
      if (num){
        let formattedNum =
        "(" + num.slice(0, 3) + ") " + num.slice(3, 6) + "-" + num.slice(6);
      return formattedNum;
      }
    },
    formatSIM(num) {
      if (num ){
        let res = [...num].map((d, i) => (i) % 5 == 0 ? ' ' + d : d).join('').trim()
      return res;
      }
    },
    formatCurrency(value) {
      var absValue = Math.abs(value);
      var returnString = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(absValue);

      return value < 0 ? "(" + returnString + ")" : returnString;
    },
    formatDate(value) {
      if (value) return moment(value).format("YYYY-MM-DD");
      else return "";
    },
    formatAccountName(firstName, lastName) {
      var temp;
      if (lastName == null) {
        temp = firstName.trim();
      } else if (lastName !== null) {
        temp = (firstName + " " + lastName).trim();
      }

      if (temp.length > 20) {
        return temp.substring(0, 17) + "...";
      } else {
        return temp;
      }
    },
    formatServiceInfo(item) {
      var temp = "";
      if (item) {
        temp = item.trim();
      }

      if (temp.length > 20) {
        return temp.substring(0, 17) + "...";
      } else {
        return temp;
      }
    },

    openAccountSummaryPage(item) {
      return "/account-summary/" + item;
    },
    openEditServiceForm(item) {
      return (
        "/Services/all?ServiceId=" + item.ServiceId + "&search=" + this.search
      );
    },
    openEditChargeForm(item) {
      this.$router.push(
        "/Charges/" + item.AccountNumber + "?search=" + this.search
      );
    },
    openViewReivables(item) {
      this.$router.push(
        "/Receivables/" + item.AccountBAN + "?search=" + this.search
      );
    },
    openEditTicketForm(item) {
      return "/Tickets/" + item.AccountBAN + "?search=" + this.search;
    },
    openEditTicket(item) {
      return "/tickets/" + item.AccountBAN + "?ticketId=" + item.TicketId;
    },
    openEditAccount(item) {
      return "/accounts/all" + "?search=" + this.search + "&BAN=" + item.BAN;
    },
    openEditCharges(item) {
      return (
        "/charges/all?search=" + this.search + "&ChargeId=" + item.ChargeId
      );
    },
    numberWithCommas(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    exportReceivablesToPDF(item) {
      this.$refs.spinner.spinOn();
      axios({
        url: "/api/Receivables/DownloadPDF/" + item.DocId,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          var accountBAN = this.padLeadingZeros(item.AccountBAN, 12);
          var docId = this.padLeadingZeros(item.DocId, 10);

          var filename = accountBAN + docId;
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename + ".pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();

          var blob = new window.Blob([response.data], {
            type: "application/pdf"
          });
          var fileURL = URL.createObjectURL(blob);
          var win = window.open();
          win.document.write(
            '<iframe src="' +
              fileURL +
              '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
          );
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    },
    padLeadingZeros(num, size) {
      var s = "000000000000000" + num;
      return s.substr(s.length - size);
    },
    async reopenTicket(item) {
      var message =
        "Are you sure you would like to reopen Ticket #" + item.TicketId + "?";
      var confirmReopen = confirm(message);
      var detail = "Ticket Reopened";
      var status = "A1";
      if (confirmReopen == true) {
        var ticket = {
          AccountNumber: item.AccountBAN,
          TicketId: item.TicketId,
          TypeId: item.TypeId,
          Status: "A1",
          Detail: detail
        };
        var result = await axios.post("api/Tickets/AddTicketDetail", ticket);
        let ticketStatusResult = await axios
          .post("api/Tickets/UpdateTicketStatus", ticket)
          .then(res => {
            this.ticketsPaginationUpdated();
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    openAccountAuditLogs(item) {
      var BAN = item.BAN;
      return "/log/account/" + BAN + "/all/all";
    },
    openServiceAuditLogs(item) {
      var BAN = item.AccountBAN;
      var ServiceId = item.ServiceId;
      return "/log/service/" + BAN + "/" + ServiceId + "/all";
    },
    openChargeAuditLogs(item) {
      var BAN = item.AccountNumber;
      var ServiceId = item.ServiceId ? item.ServiceId.toString() : "all";
      var ChargeId = item.ChargeId;
      return "/log/charge/" + BAN + "/" + ServiceId + "/" + ChargeId;
    },
    isEven(n) {
      if (!isNaN(n)) {
        return n % 2 == 0;
      }
    },
    saveLastSearchBy(){
      if (this.selectedSearchItem) {
          axios
            .post("/api/User/UpdateLastSearchBy/", {
              LastSearchBy: this.selectedSearchItem
            })
            .catch(err => {
              console.log(err);
            });
        }
    },
    getLastSearchBy(){
      axios
          .get(
            "/api/User/GetLastSearchBy/"
          )
          .then(res => {
            var userProfile = res.data
            if (userProfile.LastSearchBy){
              this.selectedSearchItem = userProfile.LastSearchBy
            }
          }).catch(error => {
            console.log(err)
          })
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    },
    uppercase: function(item) {
      if (item) {
        return item.toUpperCase();
      }
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
.v-btn--icon {
  width: 45px;
  height: 45px;
}
.ticketDetail {
  border-bottom: 1px solid #e0e0e0 !important;
}
/deep/.ticketDetailColumn {
  min-width: 200px !important;
}
/deep/.ticketDetailCreatedColumn {
  min-width: 100px !important;
}
.v-expansion-panel__container:first-child {
  border-top: 1px solid #e0e0e0 !important;
}
.v-expansion-panel__container:last-child {
  border-bottom: 1px solid #e0e0e0 !important;
}
/deep/.v-expansion-panel__header {
  padding: 12px 0px !important;
}
.middleSearch{
   /* padding-top: 265px; */
   padding-top: 20vh
}
</style>
